import { FC } from 'react';
import { useResponsiveLayout } from '../../hooks/useResponsiveLayout';
import { route } from '../../service/router';
import { useLocation, useNavigate } from 'react-router-dom';
import './forgotSuccess.type';
import { renderDesktopView, renderTabletView } from './forgotSuccessHelper';
import { ForgotPasswordSuccessProps } from './forgotSuccess.type';

const ForgotPasswordSuccess: FC<ForgotPasswordSuccessProps> = () => {
  const location = useLocation();
  const { isDesktop } = useResponsiveLayout();
  const email = location.state?.email;

  const navigate = useNavigate();

  const onClickLogin = () => {
    navigate(route.login);
  };

  return (
    <div className="relative min-h-screen w-full">
      {/* If desktop screen, render desktop view */}
      {/* If tablet/mobile screen, render tablet view */}
      {isDesktop
        ? renderDesktopView(onClickLogin, email)
        : renderTabletView(onClickLogin, email)}
    </div>
  );
};
export default ForgotPasswordSuccess;
